"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = ["img[_ngcontent-%COMP%]{max-width:100%}button.edit[_ngcontent-%COMP%]{margin:0 auto 10px;display:block}"];
exports.styles = styles;
